import React, { Component } from "react";
import { Input, Label, Required } from "../Form/Form";
import AuthApiService from "../../services/auth-api-service";
import UserContext from "../../contexts/UserContext";
import Button from "../Button/Button";
import "./LoginForm.css";

class LoginForm extends Component {
  static defaultProps = {
    onLoginSuccess: () => {},
  };

  static contextType = UserContext;

  state = { error: null };

  firstInput = React.createRef();

  handleSubmit = (ev) => {
    ev.preventDefault();
    const { username, password } = ev.target;

    this.setState({ error: null });

    AuthApiService.postLogin({
      username: username.value,
      password: password.value,
    })
      .then((res) => {
        username.value = "";
        password.value = "";
        this.context.processLogin(res.authToken);
        this.props.onLoginSuccess();
      })
      .catch((res) => {
        this.setState({ error: res.error });
      });
  };

  componentDidMount() {
    this.firstInput.current.focus();
  }

  render() {
    let label1 = Label(
      { className: "login-username-input" },
      "username",
      "Enter Username"
    );
    let label2 = Label(
      { className: "login-password-input" },
      "password",
      "Enter password"
    );
    let requiredLabel = Required({});
    const { error } = this.state;
    return (
      <form className="LoginForm" onSubmit={this.handleSubmit}>
        <div role="alert">{error && <p>{error}</p>}</div>
        <div>
          <label htmlFor="login-username-input">Username</label>
          <Input
            ref={this.firstInput}
            id="login-username-input"
            name="username"
            required
          />
          {requiredLabel}
        </div>
        <div>
          <label htmlFor="login-password-input">Password</label>
          <Input
            id="login-password-input"
            name="password"
            type="password"
            required
          />
          {requiredLabel}
        </div>
        <Button className="login-submit" type="submit">
          Login
        </Button>
      </form>
    );
  }
}

export default LoginForm;
